import React from 'react';
import { FiShield, FiCloud, FiDownload, FiUpload, FiDatabase, FiActivity } from 'react-icons/fi';

const quickActions = [
  { title: 'Backup DB', icon: FiUpload, color: 'from-primary-500 to-cyan-500', desc: 'Export a secure copy' },
  { title: 'Restore DB', icon: FiDownload, color: 'from-amber-500 to-orange-500', desc: 'Import previous snapshot' },
  { title: 'Sync Cloud', icon: FiCloud, color: 'from-purple-500 to-indigo-500', desc: 'Push latest changes' },
  { title: 'Health Check', icon: FiActivity, color: 'from-emerald-500 to-lime-500', desc: 'Run diagnostics' },
];

const AdminPanel = () => {
  return (
    <div className="space-y-8 animate-fade-up">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400 uppercase tracking-wide">Control Center</p>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 flex items-center space-x-2">
            <FiShield className="text-primary-500" />
            <span>Admin Panel</span>
          </h1>
        </div>
        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-200">
          Super Admin
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {quickActions.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.title}
              className="p-5 rounded-2xl bg-white dark:bg-gray-800 shadow-lg hover:shadow-2xl transition transform hover:-translate-y-1 border border-gray-100 dark:border-gray-700"
            >
              <div className={`h-12 w-12 rounded-xl bg-gradient-to-br ${card.color} text-white flex items-center justify-center mb-3`}>
                <Icon size={22} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{card.title}</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{card.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="p-5 rounded-2xl bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center space-x-2">
            <FiDatabase className="text-primary-500" />
            <span>Data Controls</span>
          </h3>
          <div className="space-y-3">
            <label className="flex items-center justify-between bg-gray-50 dark:bg-gray-700/50 rounded-xl px-4 py-3">
              <span className="text-sm text-gray-700 dark:text-gray-200">Auto backup</span>
              <input type="checkbox" defaultChecked className="toggle-checkbox" />
            </label>
            <label className="flex items-center justify-between bg-gray-50 dark:bg-gray-700/50 rounded-xl px-4 py-3">
              <span className="text-sm text-gray-700 dark:text-gray-200">Email summary</span>
              <input type="checkbox" defaultChecked className="toggle-checkbox" />
            </label>
            <label className="flex items-center justify-between bg-gray-50 dark:bg-gray-700/50 rounded-xl px-4 py-3">
              <span className="text-sm text-gray-700 dark:text-gray-200">Lock edits</span>
              <input type="checkbox" className="toggle-checkbox" />
            </label>
          </div>
        </div>

        <div className="p-5 rounded-2xl bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Activity Feed</h3>
          <div className="space-y-3 text-sm text-gray-700 dark:text-gray-200">
            <div className="p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">• Backup completed successfully</div>
            <div className="p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">• Orders synced with cloud</div>
            <div className="p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">• New customer created by admin</div>
            <div className="p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50">• Measurement sheet exported</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;


